import BuyButton from "./CtaButton";
import { PRICE } from "../config";

export default function StickyBuyBar() {
    return (
        <div
            data-testid="sticky-mobile-cta-bar"
            className="fixed inset-x-0 bottom-0 z-40 md:hidden"
        >
            <div className="mx-3 mb-3 flex items-center justify-between gap-3 rounded-2xl border border-emerald-100 bg-white/95 p-3 pl-4 shadow-lift backdrop-blur-md">
                <div>
                    <div className="flex items-baseline gap-1.5">
                        <span className="font-display text-xl font-extrabold text-slate-900">
                            ₹{PRICE.current}
                        </span>
                        <span className="text-xs text-slate-400 line-through">
                            ₹{PRICE.original.toLocaleString("en-IN")}
                        </span>
                    </div>
                    <span className="text-[10px] font-bold uppercase tracking-wider text-orange-600">
                        Festive Offer · {PRICE.off}% off
                    </span>
                </div>
                <BuyButton
                    testId="sticky-buy-now-btn"
                    className="px-6 py-3 text-sm"
                >
                    Buy Now
                </BuyButton>
            </div>
        </div>
    );
}
